// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Button, Text } from '@mantine/core';
import { IconCalendarTime } from '@tabler/icons';
import { RoutingS } from '../../../../Service/RoutingS';
import BookitupAlert from '../../../../Atoms/BookitupAlert';

const MailgunVerificationAlert = () => (
  <BookitupAlert title="Hilfe erforderlich?" my="md">
    <Text>
      Hast du Probleme beim Einrichten? Mach einfach einen Termin mit unserem Technik-Support und wir lösen das Problem
      gemeinsam.
    </Text>
    <Button
      size="xs"
      leftIcon={<IconCalendarTime size={16} />}
      mt="md"
      onClick={() => RoutingS.openInNewTab('https://hey.bookitup.de/meetings/sebastian-mahlke/technik-support')}
    >
      Termin vereinbaren
    </Button>
  </BookitupAlert>
);

export default MailgunVerificationAlert;
